import { render, staticRenderFns } from "./CreateBorrowRequestDialog.vue?vue&type=template&id=20da2505&"
import script from "./CreateBorrowRequestDialog.vue?vue&type=script&lang=js&"
export * from "./CreateBorrowRequestDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports